<script>
import ProfileData from './ProfileData';
import { defaultNames } from '../helpers/constants';
export default {
	mixins: [ProfileData],
	computed: {
		constants() {
			return this.$store.getters.constants;
		},
		SAVINGS_BUDGET_MIN_WITHOUT_CHILDREN() {
			if (this.constants) {
				return this.constants.savingsBudgetMinWithoutChildren;
			}
			return null;
		},
		SAVINGS_BUDGET_MAX_WITHOUT_CHILDREN() {
			if (this.constants) {
				return this.constants.savingsBudgetMaxWithoutChildren;
			}
			return null;
		},
		SAVINGS_BUDGET_MIN_WITH_CHILDREN() {
			if (this.constants) {
				return this.constants.savingsBudgetMinWithChildren;
			}
			return null;
		},
		SAVINGS_BUDGET_MAN_WITH_CHILDREN() {
			if (this.constants) {
				return this.constants.savingsBudgetMaxWithChildren;
			}
			return null;
		},
		savingsSubcategories() {
			let savingsSubcategories = this.$store.getters.savings;
			savingsSubcategories.forEach(saving => {
				if (saving.name === defaultNames.NAME_GENERAL_SAVINGS) {
					if (this.profileData.studentChildren.length) {
						saving.minimum = this.calculateGuideLine(
							this.SAVINGS_BUDGET_MIN_WITH_CHILDREN
						);
						saving.maximum = this.calculateGuideLine(
							this.SAVINGS_BUDGET_MAN_WITH_CHILDREN
						);
					} else {
						saving.minimum = this.calculateGuideLine(
							this.SAVINGS_BUDGET_MIN_WITHOUT_CHILDREN
						);
						saving.maximum = this.calculateGuideLine(
							this.SAVINGS_BUDGET_MAX_WITHOUT_CHILDREN
						);
					}
				}
			});
			return savingsSubcategories;
		}
	},
	methods: {
		getTotalSavingsAmount(useLocal) {
			if (useLocal) {
				return this.savingsSubcategories.reduce((sum, item) => {
					if (item.amount > 0) {
						return sum + parseInt(item.amount);
					} else {
						return sum;
					}
				}, 0);
			}

			return this.$store.getters.savingsTotalAmount;
		}
	}
};
</script>
